// extracted by mini-css-extract-plugin
export default {"wrapper":"LayoutHeader_wrapper__RBq1O","goBackLink":"LayoutHeader_goBackLink__kQERh"};